export default __webpack_public_path__ + "static/react-f098a313abafa8642511eabdfa6dfd8e.svg";